import {
    Box, Typography
} from '@mui/material'
import Banner1 from '../../../assets/banner/banner1.jpg'
import Banner2 from '../../../assets/banner/banner2.png'
import Banner3 from '../../../assets/banner/banner3.jpg'
import Banner4 from '../../../assets/banner/banner4.jpg'
import '../../../common/set1.css'
import '../../../common/normalize.css'
import { useState } from 'react'
import { MOTORLOAN_LINK, ROOT_PATH } from '../../../common/config'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

const bannerList = [
    Banner1,
    Banner2,
    Banner3,
    Banner4,
]

export const SMHomeBanner: React.FC = () => {

    const [bannerIndex, updateIndex] = useState(0)

    const { t } = useTranslation()

    const handleMouseEnter1 = () => {
        updateIndex(0)
    }
    const handleMouseEnter2 = () => {
        updateIndex(1)
    }
    const handleMouseEnter3 = () => {
        updateIndex(2)
    }
    const handleMouseEnter4 = () => {
        updateIndex(3)
    }
    // 打开motorloan
    const goToMotorloan = () => {
        window.open(MOTORLOAN_LINK)
    }
    // 打开新页面
    const goToNewPage = (path: String, index: number) => {
      if (path !== '') {
        window.location.replace(ROOT_PATH + path) 
      }
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                height: '800px',
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'row',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundImage: `url(${bannerList[bannerIndex]})`,
            }}
        >
            <Box sx={{ position: 'absolute', 
                left: 0, top: 0, right: 0, bottom: 0, 
                backgroundColor: bannerIndex === 1 ? 'transparent' : 'rgba(0,0,0,0.3)', 
                justifyContent: 'space-between',
                display: 'flex', 
                flexDirection: 'row' }}>

            {/* One */}
            <Box
                sx={{
                    flex: 1,
                    textAlign: 'center',
                    padding: '10px',
                    alignItems: 'center',
                    justifyContent: 'start',
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: isTablet ? '20px' : '30px',
                    paddingRight: isTablet ? '10px' : '30px',
                    paddingTop: '500px',
                }}
                onMouseEnter={handleMouseEnter1}
                onClick={()=> goToNewPage(ROOT_PATH + '/motorcycle-financing')}
            >
                <>
                {isTablet ?  (
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        textAlign: 'left'
                    }}>
                        <Typography fontSize={26} fontWeight={700} color={'#FFFFFF'}>
                            {t('t18')}
                        </Typography>
                        <Typography fontSize={26} fontWeight={700} color={'#FFFFFF'}>
                            {t('t19')}
                        </Typography>
                        <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} paddingTop={'10px'}>
                            {t('t26')}
                        </Typography>
                    </Box> 
                ) : (
                    <figure className='effect-lily'>
                    <figcaption>
                        <div>
                            <h2 style={{ color: '#FFFFFF', fontSize: '26px', fontWeight: '700', cursor: 'pointer' }}>
                                <div>{t('t18')}</div>
                                <div>{t('t19')}</div>
                            </h2>
                            <p style={{ color: '#FFFFFF', fontSize: '16px', cursor: 'pointer' }}>{t('t26')}</p>
                        </div>
                    </figcaption>
                </figure>
                )}
                </>
            </Box>

            <Box sx={{ height: '100%', width: '1px', background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0.0), rgba(255, 255, 255, 0.5))', }}>
            </Box>

            {/* Two */}
            <Box
                sx={{
                    flex: 1,
                    textAlign: 'center',
                    padding: '10px',
                    alignItems: 'center',
                    justifyContent: 'start',
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: isTablet ? '20px' : '30px',
                    paddingRight: isTablet ? '10px' : '30px',
                    paddingTop: '500px',
                }}
                onMouseEnter={handleMouseEnter2}
                onClick={()=> goToNewPage(ROOT_PATH + '/personal-loan')}

            >
                <>
                {isTablet ?  (
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        textAlign: 'left'
                    }}>
                        <Typography fontSize={26} fontWeight={700} color={'#FFFFFF'}>
                            {t('t20')}
                        </Typography>
                        <Typography fontSize={26} fontWeight={700} color={'#FFFFFF'}>
                            {t('t21')}
                        </Typography>
                        <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} paddingTop={'10px'}>
                            {t('t27')}
                        </Typography>
                    </Box> 
                ) : (
                    <figure className='effect-lily'>
                    <figcaption>
                        <div>
                            <h2 style={{ color: '#FFFFFF', fontSize: '26px', fontWeight: '700', cursor: 'pointer' }}>
                                <div>{t('t20')}</div>
                                <div>{t('t21')}</div>
                            </h2>
                            <p style={{ color: '#FFFFFF', fontSize: '16px', cursor: 'pointer' }}>{t('t27')}</p>
                        </div>
                    </figcaption>
                </figure>
                )}
                </>    
            </Box>

            <Box sx={{ height: '100%', width: '1px', background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0.0), rgba(255, 255, 255, 0.5))', }}>
            </Box>

            {/* Three */}
            <Box
                sx={{
                    flex: 1,
                    textAlign: 'center',
                    padding: '10px',
                    alignItems: 'center',
                    justifyContent: 'start',
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: isTablet ? '20px' : '30px',
                    paddingRight: isTablet ? '10px' : '30px',
                    paddingTop: '500px',
                }}
                onMouseEnter={handleMouseEnter3}
                onClick={()=> goToNewPage(ROOT_PATH + '/motor-vehicle')}
            >
                <>
                {isTablet ?  (
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        textAlign: 'left'
                    }}>
                        <Typography fontSize={26} fontWeight={700} color={'#FFFFFF'}>
                            {t('t22')}
                        </Typography>
                        <Typography fontSize={26} fontWeight={700} color={'#FFFFFF'}>
                            {t('t23')}
                        </Typography>
                        <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} paddingTop={'10px'}>
                            {t('t28')}
                        </Typography>
                    </Box> 
                ) : (
                    <figure className='effect-lily'>
                    <figcaption>
                        <div>
                            <h2 style={{ color: '#FFFFFF', fontSize: '26px', fontWeight: '700', cursor: 'pointer' }}>
                                <div>{t('t22')}</div>
                                <div>{t('t23')}</div>
                            </h2>
                            <p style={{ color: '#FFFFFF', fontSize: '16px', cursor: 'pointer' }}>{t('t28')}</p>
                        </div>
                    </figcaption>
                </figure>
                )}
                </>
            </Box>

            <Box sx={{ height: '100%', width: '1px', background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0.0), rgba(255, 255, 255, 0.5))', }}>
            </Box>

            {/* Four */}
            <Box
                sx={{
                    flex: 1,
                    textAlign: 'center',
                    padding: '10px',
                    alignItems: 'center',
                    justifyContent: 'start',
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: isTablet ? '20px' : '30px',
                    paddingRight: isTablet ? '10px' : '30px',
                    paddingTop: '500px',
                }}
                onMouseEnter={handleMouseEnter4}
                onClick={goToMotorloan}
            >
                
                <>
                {isTablet ?  (
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        textAlign: 'left'
                    }}>
                        <Typography fontSize={26} fontWeight={700} color={'#FFFFFF'}>
                            {t('t24')}
                        </Typography>
                        <Typography fontSize={26} fontWeight={700} color={'#FFFFFF'}>
                            {t('t25')}
                        </Typography>
                        <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} paddingTop={'10px'}>
                            {t('t29')}
                        </Typography>
                    </Box> 
                ) : (
                    <figure className='effect-lily'>
                    <figcaption>
                        <div>
                            <h2 style={{ color: '#FFFFFF', fontSize: '26px', fontWeight: '700', cursor: 'pointer' }}>
                                <div>{t('t24')}</div>
                                <div>{t('t25')}</div>
                            </h2>
                            <p style={{ color: '#FFFFFF', fontSize: '16px', cursor: 'pointer' }}>{t('t29')}</p>
                        </div>
                    </figcaption>
                </figure>
                )}
                </>
            </Box>
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMHomeBanner
